import { Trans } from 'react-i18next';
import React from 'react';

const tabComponentsByIdToTabs = (tabComponentsByTabId) =>
  Object.keys(tabComponentsByTabId).map((tabId) => ({
    id: tabId,
    component: tabComponentsByTabId[tabId],
  }));

const addPlatformSettingsTabGroupId = (tabGroupId) => (tab) => ({
  ...tab,
  tabGroupId,
});

const addPlatformSettingsTabTranslatedLabel = (tab) => ({
  ...tab,
  label: <Trans i18nKey={`admin-page.platform-settings.${tab.tabGroupId}.${tab.id}.tab-label`} />,
});

export const generatePlatformSettingsTabs = (tabComponentsByTabId, tabGroupId) =>
  tabComponentsByIdToTabs(tabComponentsByTabId)
    .map(addPlatformSettingsTabGroupId(tabGroupId))
    .map(addPlatformSettingsTabTranslatedLabel);

export const addTabGroupTranslatedLabel = (tabGroupId) => ({
  id: tabGroupId,
  groupName: <Trans i18nKey={`admin-page.platform-settings.${tabGroupId}.tab-group-title`} />,
});
